import { render } from "./Task.vue?vue&type=template&id=3d404ff4&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=3d404ff4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d404ff4"

export default script